import React from "react";
import { renderToString } from "react-dom/server";
import Note from "./Note";

function render(text: string) {
  return renderToString(<Note text={text} />);
}

export default render;
